import {useState} from 'react';
import {ReadAudience} from '@tinct/core-api-models';
import {usePatchAudience} from '@tinct/core-api';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from '@tinct/web-components';
import {toast} from 'sonner';

type RenameAudienceModalProps = {
  audience: ReadAudience;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRenamed?: () => void;
};

export const RenameAudienceModal = ({
  audience,
  open,
  onOpenChange,
  onRenamed,
}: RenameAudienceModalProps) => {
  const [name, setName] = useState(audience.name ?? '');

  const {mutate: patchAudience, isPending} = usePatchAudience({
    onSuccess: () => {
      toast.success(`${name} successfully renamed.`);
      onOpenChange(false);
      onRenamed?.();
    },
  });

  const handleSave = () => {
    if (!audience.id || !name.trim()) return;
    patchAudience({id: audience.id, data: {name: name.trim()}});
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Rename an audience</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <Label htmlFor="audience-name">Name</Label>
          <Input
            id="audience-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSave();
            }}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={isPending || !name.trim()}
          >
            Save changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
